import I18n from 'Pods/Shared/I18n'

const PRODUCT_TYPES = ['model', 'printable', 'cad', 'scene', 'pack']

export const productTypeLabel = (value) => I18n.t(`profile.my_models.product_types.${value}`, { ns: 'rails' })

export const productTypeOptions = (cadProductTypeEnabled) => PRODUCT_TYPES
  .filter((value) => value !== 'cad' || cadProductTypeEnabled)
  .map((value) => ({ value, label: productTypeLabel(value) }))
